import React, { useEffect, useState } from 'react';
import { Box, Button, Flex, Text, Image } from 'rebass';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Formik, Form, Field } from 'formik';
import store from 'store';

import { object, string } from 'yup';
import ImageRenderer from './components/ImageRenderer';
import VideoRenderer from './components/VideoRenderer';
import useEntity from 'entities/hooks/use-entity';
import Wrapper from './Wrapper';
import { CiLock } from "react-icons/ci";
import { useWindowSize } from 'react-use';
import { IoIosArrowBack } from 'react-icons/io';
import useHistory from 'app/hooks/history';
import useLocation from 'app/hooks/location';
import AdorableBabyAnimal from './assets/Adorable-baby-animal.png';
import useEntityActionCreators from 'entities/hooks/use-entity-action-creators';
import { patchChildJournal } from 'child-journals/api';
import TextField from 'app/form/formik/text/index';
import { label } from 'babys-first-year/SignUp';
import { prepareAttrs } from 'utils/api';
import FirstTimeUserExperience from './FirstTimeUserExperience';
import Loading from 'app/loading/index';
import PaymentBlocker from 'collections/milestones/PaymentBlocker';

const formatAge = (age) => {
  const ageMapping = {
    new_born: "Newborn",
    one_month: "1 Month",
    two_month: "2 Months",
    three_month: "3 Months",
    four_month: "4 Months",
    five_month: "5 Months",
    six_month: "6 Months",
    seven_month: "7 Months",
    eight_month: "8 Months",
    nine_month: "9 Months",
    ten_month: "10 Months",
    eleven_month: "11 Months",
    twelve_month: "12 Months",
  };

  return ageMapping[age] || "Unknown Age";
};

function LockedIcon({ onClick }) {
  return <Box width={["122px", "153px"]} height={["149.661px", "188.128px"]}>
    <Flex
      fontWeight="normal"
      fontSize={2}
      flex={1}
      height="100%"
      justifyContent="center"
      flexDirection="column"
      alignItems={'center'}
      textAlign="center"
      p={3}
      bg="rgba(100, 116, 139, 0.10)"
      color="#64748B"
      sx={{ borderRadius: 12, cursor: 'pointer', border: '1.5px dashed #64748B' }}
      onClick={onClick}
    >
      <Text as={CiLock} color="#64748B" size={48} />
    </Flex>
  </Box>
}

const AgeRenderer = ({ age }) => {
  const [number, ...textParts] = age.split(' ');
  const text = textParts.join(' ');

  if (age === "Newborn") {
    return (
      <Flex m={["unset", "auto"]} flexDirection={'column'} alignItems="center" gap="10px">
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="58" viewBox="0 0 42 58" fill="none">
          <path d="M22.9801 57.3931C21.6105 57.3978 20.1955 57.4709 18.8315 57.3636C9.83342 56.6557 2.71097 49.5658 2.28415 40.4521L2.26915 34.7886C2.26868 34.0915 2.2913 33.3849 2.24267 32.6897C0.849842 31.9821 0.098477 30.3302 0.000646061 28.823C-0.0225522 28.4654 0.585289 26.426 0.808484 26.1828C1.82018 25.0805 2.88672 24.8414 4.28412 24.7766L4.28236 21.1607C4.28259 20.3574 4.25963 19.5431 4.32466 18.7418C4.92863 11.2901 10.7547 4.37119 18.2889 3.2783C18.6523 1.36653 20.0623 0.13844 22.0275 0C22.6461 0.0348442 23.2161 0.570372 22.8496 1.22421C22.347 2.12087 21.1123 1.01437 20.0163 3.05873C21.0291 3.04245 22.0828 2.9991 23.0917 3.08767C30.8208 3.7664 37.7498 11.4044 37.8374 19.1072L37.8459 25.2129C38.7272 25.2159 39.4966 25.3051 40.2436 25.8148C42.299 27.2172 42.7451 30.9236 40.5303 32.39C40.3876 32.4844 39.9682 32.5804 39.8939 32.6923C39.8394 32.7744 39.8711 34.13 39.8708 34.3325L39.8679 38.1386C39.8663 39.8566 39.8414 41.5335 39.509 43.2267C37.9468 51.1832 31.0272 57.0113 22.9801 57.3931ZM12.764 27.1141L12.7462 27.0882C11.7645 25.69 11.0434 24.9529 10.4802 23.1609C10.3974 22.8977 10.4163 22.9247 10.1619 22.8344C6.8781 21.6684 7.30645 17.6409 10.4435 16.6668C11.3197 11.8848 14.1981 8.99643 19.039 8.64998L19.02 8.62526C18.1592 7.48479 17.9016 6.34386 18.0256 4.94107L17.2573 5.11354C11.0008 6.78779 6.31467 12.5865 5.91561 19.0354C5.85644 19.9897 5.89792 20.9702 5.89839 21.9265C5.89897 22.9584 5.84355 24.0245 5.91186 25.0527C6.26897 25.1715 6.67693 25.2133 7.04647 25.3065L11.6125 26.7127C11.9599 26.8407 12.4072 27.0795 12.764 27.1141ZM23.3561 4.66082C23.6128 5.12267 23.7194 5.59707 23.5565 6.11539C22.9675 7.98871 19.9897 7.2234 20.7789 5.53415C20.9092 5.2553 21.1223 5.11213 21.4091 5.01922L21.5632 4.92865C21.2551 4.59732 20.2531 4.70475 19.8466 4.78888C19.0088 6.87426 20.8213 8.71641 22.5694 9.55565C23.4951 9.1505 24.3946 8.05877 25.1764 8.35766C28.8843 9.77544 30.9193 13.0504 31.784 16.8043C34.877 17.8291 34.864 22.1799 31.707 22.7861C30.135 27.5728 26.1638 30.494 21.1643 30.545C20.5187 30.5477 19.8213 30.5855 19.1869 30.4554L18.8675 30.4132L24.614 34.696L28.4501 31.554L32.3876 28.7283L35.773 26.529C35.9386 26.4131 36.0536 26.3944 36.1873 26.2258L36.2159 19.5161C36.192 12.1031 30.4946 6.125 23.3561 4.66082ZM24.9769 10.0434C24.2385 10.613 23.2314 11.2886 22.3034 11.4604C21.798 11.3092 21.3567 10.9748 20.8819 10.7472C19.0921 9.88886 17.7202 10.1102 15.9622 11.0532C13.8499 12.1864 12.3862 14.3482 11.9965 16.7045C11.6797 18.6198 11.6118 18.0648 10.1959 18.5732C9.1049 18.965 9.41866 20.9314 10.4628 21.2048C11.5067 21.478 11.5634 21.2062 11.9038 22.3098C12.6852 24.8433 14.414 26.8811 16.8205 28.0459C21.5464 30.0964 27.5564 28.4671 29.676 23.5191L30.0169 22.6246C30.3574 21.6433 30.2147 21.3958 31.2634 21.2501C32.5112 21.0769 33.0318 19.187 31.7732 18.6023C30.3995 17.9641 30.3711 18.5466 30.1368 16.8256C29.6966 13.5921 27.6459 11.5612 24.9769 10.0434ZM3.82203 26.5839C3.21243 26.6349 2.62978 26.7509 2.20518 27.2338C1.4571 28.0842 1.69049 30.1053 2.55386 30.8169C3.11601 31.2803 3.54658 31.5641 3.76825 32.2972L3.78137 32.3394C3.96485 32.9662 3.87791 33.7841 3.87838 34.4284L3.88014 37.1655C3.88108 38.7611 3.83644 40.3428 4.06772 41.9273C5.08739 48.9099 10.7489 54.7436 17.7835 55.6369C20.1184 55.9336 23.481 55.9256 25.7489 55.4012C32.8318 53.7634 37.795 47.7426 38.2606 40.5352C38.3288 39.48 38.2726 38.3846 38.2736 37.3249L38.2754 34.8558C38.2756 34.4273 38.2957 33.9877 38.2711 33.5608L38.2535 33.5897C38.1401 33.7685 37.5841 34.1172 37.3919 34.2641L35.6263 35.6985C34.2226 36.9196 32.9929 38.2767 31.7854 39.6875L28.904 43.1944C26.1989 46.6269 23.6693 50.5185 19.5409 52.3726C19.0913 52.5744 18.3193 52.9315 17.8175 52.7919C16.963 52.5542 17.1935 51.5594 17.9396 51.2288C18.4628 50.9969 19.0027 50.8408 19.5147 50.5736C21.5789 49.497 23.3123 47.7019 24.75 45.8973C28.6078 41.1178 32.1211 35.8169 37.2731 32.3095C37.708 32.0134 38.1519 31.7254 38.6329 31.509C38.9979 31.3448 39.4243 31.2385 39.7576 31.0173C40.9557 30.2221 40.572 26.9929 38.4967 26.8355C38.1613 26.9953 37.8712 27.2267 37.5554 27.4202L35.2546 28.841C32.1501 30.7955 29.2155 32.9369 26.4141 35.307L21.5722 39.7545L16.4517 44.741L12.2005 49.154C11.7056 49.7009 10.7412 50.6612 10.2197 49.5133C9.93394 48.8842 10.7628 48.3259 11.1271 47.9275L16.4806 42.467L23.3874 35.8396L19.8624 33.0014C16.3606 30.4366 12.3245 28.4947 8.14932 27.3154C6.8146 26.9384 5.22529 26.4933 3.82203 26.5839Z" fill="#64748B" />
          <path d="M24.8235 20.9718C23.3152 20.9569 23.0985 18.9317 24.7032 18.6699C26.239 18.7153 26.3223 20.7193 24.8235 20.9718ZM17.5159 20.9909C15.9771 21.179 15.4818 19.1843 16.9941 18.7011C18.5376 18.4821 19.0221 20.4638 17.5159 20.9909ZM18.7996 25.2731C18.0836 24.792 17.6749 23.8359 18.6875 23.5131C19.3176 23.3121 19.5616 23.8736 20.0454 24.1173C21.4689 24.8342 22.0558 23.7376 22.9675 23.4218C23.6553 23.4321 24.0832 24.0675 23.6868 24.7005C22.7304 26.2277 20.2246 26.1436 18.7996 25.2731Z" fill="#64748B" />
        </svg>
        <Text
          sx={{
            textAlign: 'center',
            color: '#64748B',
            fontFamily: 'Poppins',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '150%',
          }}
        >
          {age}
        </Text>
      </Flex>
    );
  }

  return (
    <Flex m={["unset", "auto"]} flexDirection={'column'} alignItems="center" gap="10px">
      <Text
        sx={{
          textAlign: 'center',
          WebkitTextStrokeWidth: '1px',
          WebkitTextStrokeColor: '#64748B',
          color: 'transparent',
          fontFamily: 'Poppins',
          fontSize: '70px',
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: '150%',
        }}
      >
        {number}
      </Text>
      <Text
        sx={{
          color: '#64748B',
          textAlign: 'center',
          fontFamily: 'Poppins',
          fontSize: '18px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '150%', // 27px
        }}
      >
        {text}
      </Text>
    </Flex>
  );
};

const WatchMeGrowForm = () => {
  const params = useParams();
  const { entity } = useEntity(params);
  const { revalidate: revalidateJournal } = useSWR(`/v3/child_journals/${params.id}`)
  const firstBookId = entity?.books?.[0]?.id || '';
  const { push, goBack } = useHistory();
  const { search } = useLocation();

  const [showPaymentPage, setShowPaymentPage] = useState(null);
  const { 'first-name': firstName } = entity

  const allowedStoriesCreation = entity?.['maximum-watch-me-grow-months-permitted'];
  const isOnFreeTrial = !entity?.['child-journal-watch-me-grow-permitted'];

  const { width } = useWindowSize();
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [ftue, setFtue] = useState(false)
  const [mediaFtue, setMediaFtue] = useState(false)

  const { receive } = useEntityActionCreators();

  const { data, revalidate } = useSWR(firstBookId ? `/v3/books/${firstBookId}/watch_me_grow_months` : null);
  const monthsData = data?.data?.data || [];

  function onTrialClick() {
    setShowPaymentPage(true);
    push(`?step=1`)
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(search);
    const stepFromUrl = queryParams.get('step');
    if (stepFromUrl) {
      setShowPaymentPage(true)
    }
    else
      setShowPaymentPage(false)

  }, [search]);

  useEffect(() => {
    if (!store.get('wmg_ftui_watched')) {
      setFtue(true)
    }
  }, [])

  useEffect(() => {
    revalidateJournal();
  }, [showPaymentPage])

  const initialValues = {
    'first-name-noac': (entity && entity?.['first-name']) || '',
  };

  const validationSchema = object().shape({
    'first-name-noac': string().required('Name is required'),
  });
  const isInitialValid = validationSchema.isValidSync(initialValues);

  async function onSubmit(values) {
    const attributes = prepareAttrs(values);

    // if (!values['first-name-noac'])
    //   attributes['first-name'] = 'Baby';

    setIsSubmitting(true)

    let cjRes = await patchChildJournal({ id: entity?.id, ...attributes });

    receive({ payload: cjRes });
    setFtue(true);
    setMediaFtue(true);
    setIsSubmitting(false)
  }

  if (Object.keys(entity).length === 0)
    return <Box m={width < 600 ? 2 : 4}  >
      <Loading />
    </Box>

  // `child-journal-wmg-permitted` is edition eligibility (true only for a First
  // Year journal), separate from `child-journal-watch-me-grow-permitted` (whether
  // this journal has paid for it). A Second-Fifth Year journal never has Watch Me
  // Grow at all, regardless of purchases, so this takes priority over the
  // purchase-driven checkout step below.
  if (entity?.['child-journal-wmg-permitted'] === false)
    return <Box m={width < 600 ? 2 : 4} mr={2} >
      <Box sx={width < 600 && { bg: '#fff', position: 'fixed', bottom: 0, left: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }} p={2}>
        <Flex
          height={40}
          width="min-content"
          justifyContent="space-around"
          alignItems="center"
          sx={{ borderRadius: 'medium', cursor: 'pointer' }}
          onClick={goBack}
        >
          <Text as={IoIosArrowBack} color="mineShaft" size={24} />
          <Text minWidth={'max-content'} color="mineShaft" fontFamily="Poppins" lineHeight={'150%'} ml={1} fontWeight={400} fontSize="15px">
            Back
          </Text>
        </Flex>
      </Box>
      <PaymentBlocker sku="by-feature-watchmegrow" />
    </Box>

  if (showPaymentPage)
    return <Box m={width < 600 ? 2 : 4} mr={2} >
      <Box sx={width < 600 && { bg: '#fff', position: 'fixed', bottom: 0, left: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }} p={2}>
        <Flex
          height={40}
          width="min-content"
          justifyContent="space-around"
          alignItems="center"
          sx={{ borderRadius: 'medium', cursor: 'pointer' }}
          onClick={goBack}
        >
          <Text as={IoIosArrowBack} color="mineShaft" size={24} />
          <Text minWidth={'max-content'} color="mineShaft" fontFamily="Poppins" lineHeight={'150%'} ml={1} fontWeight={400} fontSize="15px">
            Back
          </Text>
        </Flex>
        <svg xmlns="http://www.w3.org/2000/svg" width="70vw" height="2" viewBox="0 0 70vw 2" fill="none">
          <path d="M0 1L1027 1.00009" stroke="#E2E8F0" stroke-width="0.5" />
        </svg>
      </Box>
      <PaymentBlocker sku="by-feature-watchmegrow" />
    </Box>

  if (!entity?.['first-name'])
    return (
      <Box m="auto" mb={9} maxWidth={600}>
        <Image src={AdorableBabyAnimal} />
        <Flex flexDirection={"column"} p={2}>
          <Text textAlign="center" fontFamily="Bitter" fontSize={30} letterSpacing="-0.18px" color="#000" lineHeight="120%" mt={3}>
            Welcome to Watch Me Grow!
          </Text>
          <Text color="#64748B" fontFamily="Poppins" textAlign="left" fontSize={18} letterSpacing="0.16px" lineHeight="200%" mt={2} mb={3}>
            Let’s prepare your printable collage title with your baby’s name.
          </Text>
          <Formik
            {...{ initialValues, validationSchema, isInitialValid }}
            enableReinitialize
            onSubmit={onSubmit}
          >
            <Form>
              <Flex flexDirection={"column"}>

                <Field
                  component={TextField}
                  name="first-name-noac"
                  label={label("Baby's first name", true)}
                  // subText="Leave blank if undecided yet"
                  showError
                  placeholder="First Name"
                  mb={1}
                />
                <Button m="auto" mt={3} type='submit' disabled={isSubmitting} sx={{ width: 'max-width', borderRadius: '23px', height: 44, py: 'unset' }} variant="primary">
                  Update Name
                </Button>
              </Flex>
            </Form>
          </Formik>
        </Flex>
      </Box>
    );

  return (
    <Wrapper isOnFreeTrial={isOnFreeTrial} onTrialClick={onTrialClick}>
      {ftue && <FirstTimeUserExperience setShowFTUE={setFtue} />}
      <Flex alignItems="center" justifyContent={['center', 'center', 'center', "left"]} gap="10px" sx={{
        pb: 3
      }}>
        <Text fontFamily="Poppins" textAlign="center" fontSize={22} letterSpacing="0.22px" lineHeight="165%">
          Watch {firstName} Grow
        </Text>
        {isOnFreeTrial && <Button
          onClick={onTrialClick}
          p="10px 30px !important"
          sx={{
            display: ['none', 'none', 'none', 'flex'],
            borderRadius: '30px', ml: 5
          }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12.2693 9.53516V9.53668M7.7308 9.53668C7.72702 9.53668 7.7336 9.53668 7.72888 9.53668" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10 16.9454C13.1288 16.9439 15.8701 14.8504 16.6953 11.8324C17.6301 11.7306 18.3382 10.9412 18.3382 10.0009C18.3382 9.06053 17.6301 8.2711 16.6953 8.16926C15.8723 5.14967 13.1298 3.05469 10 3.05469C6.87028 3.05469 4.12782 5.14967 3.30475 8.16926C2.36997 8.2711 1.66187 9.06053 1.66187 10.0009C1.66187 10.9412 2.36997 11.7306 3.30475 11.8324C4.12994 14.8504 6.87131 16.9439 10 16.9454Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.8524 12.5087C10.7911 13.4346 9.20894 13.4346 8.14758 12.5087M9.07377 5.99258C9.34286 6.18886 9.66694 6.29534 10 6.29687C10.881 6.27689 11.5848 5.55699 11.5848 4.67578C11.5848 3.79457 10.881 3.07466 10 3.05469" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          &nbsp;
          Unlock Watch Me Grow
        </Button>}
      </Flex>
      <Box my={4} mt={10} sx={{ border: '0.5px solid #E2E8F0' }} />
      <Box m="auto" maxWidth={626}>
        {monthsData.map((month, index) => {
          const { age, id } = month.attributes;
          const { 'image-clip': image, 'video-clip': video } = month.relationships;
          const isLocked = isOnFreeTrial && index + 1 > allowedStoriesCreation;

          return (
            <Flex maxWidth={574} key={index} mb={3} alignItems={'center'} gap="30px" justifyContent={'space-around'}>
              <AgeRenderer age={formatAge(age)} />
              <Flex
                ml="auto"
                maxWidth={[284, 379]}
                justifyContent="space-between"
                sx={{
                  p: ['15px', '28px'],
                  gap: ['10px', '20px'],
                  borderRadius: '10px',
                  background: '#FFF'
                }}>
                {isLocked ?
                  <LockedIcon onClick={onTrialClick} />
                  : <ImageRenderer mediaFtue={mediaFtue} setMediaFtue={setMediaFtue} age={formatAge(age)} firstBookId={firstBookId} revalidate={revalidate} monthId={id} image={image?.data} />}
                {isLocked ?
                  <LockedIcon onClick={onTrialClick} border="1px dashed #9B59B6" />
                  : <VideoRenderer mediaFtue={mediaFtue} setMediaFtue={setMediaFtue} age={formatAge(age)} revalidate={revalidate} monthId={id} video={video?.data} />}
              </Flex>
            </Flex>
          );
        })}
      </Box>
    </Wrapper>
  );
};

export default WatchMeGrowForm;